import React from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const inputCls =
  "w-full px-3.5 py-2.5 text-[13px] font-semibold text-black bg-white border-2 border-black/10 rounded-xl focus:border-[#0fb013] focus:outline-none transition-colors";
export const labelCls = "block text-[10px] font-bold uppercase tracking-wider text-black/45 mb-1";
export const btnPrimary =
  "inline-flex items-center justify-center gap-1.5 text-[12px] font-bold text-black bg-[#0fe814] hover:bg-[#0fb013] px-4 py-2.5 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
export const btnGhost =
  "inline-flex items-center justify-center gap-1.5 text-[12px] font-bold text-black px-4 py-2.5 rounded-full border-2 border-black/15 hover:border-black transition-colors disabled:opacity-50";

export const TX_METHODS = { tarjeta: "Tarjeta", yappy: "Yappy", ach: "ACH", cripto: "Cripto", otro: "Otro" };
export const TX_TYPES = { venta: "Venta", reembolso: "Reembolso", cashout: "Cashout", comision: "Comisión" };
export const TX_STATUSES = { aprobada: "Aprobada", pendiente: "Pendiente", rechazada: "Rechazada" };
export const KYC_CATEGORIES = {
  cedula_pasaporte: "Cédula o Pasaporte",
  aviso_operaciones: "Aviso de Operaciones",
  registro_publico: "Registro Público",
  carta_bancaria: "Carta Bancaria",
  recibo_servicio: "Recibo de Servicio",
  otro: "Otro",
};
export const KYC_VERIFICATION = {
  pendiente: { label: "Pendiente", cls: "bg-amber-100 text-amber-700" },
  verificado: { label: "Verificado", cls: "bg-[#0fe814]/15 text-[#0fb013]" },
  rechazado: { label: "Rechazado", cls: "bg-[#ff603e]/10 text-[#ff603e]" },
};

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDateTime = (iso) => {
  try {
    return new Date(iso).toLocaleString("es-PA", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const Field = ({ label, children, className = "" }) => (
  <div className={className}>
    <label className={labelCls}>{label}</label>
    {children}
  </div>
);

export const Empty = ({ icon: Icon, text }) => (
  <div className="py-10 text-center">
    {Icon && <Icon size={30} className="mx-auto text-black/20" />}
    <p className="mt-2 text-[13px] font-bold text-black/45">{text}</p>
  </div>
);
